export default __webpack_public_path__ + "static/media/leave.0069f48c.svg";